import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { Availabilities } from '@/schemas/API/GET/employee/availability/response';

/**
 * Hook that fetches employee's availabilities based on the employeeId in the URL.
 */
const useAvailabilities = () => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: availabilities,
    error,
    mutate,
  } = useSWR<Availabilities>(
    employeeId ? `/employees/${employeeId}/availabilities` : null,
    async () =>
      await getFetcher(`/employees/${employeeId}/availabilities?size=500`)
  );

  return {
    availabilities,
    error,
    mutate,
  };
};

export default useAvailabilities;
